import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'
import { renderMarkdown } from 'lib/string/markdownUtils'
import LayoutContainer from 'components/Common/LayoutContainer'
import BodyText from 'LuxKit/Typography/BodyText'
import FullWidthCarousel from 'LuxKit/Carousel/FullWidthCarousel'
import ComponentDynamicBanner from 'marketing/components/ComponentDynamicBanner'
import styled from 'styled-components'
import { rem } from 'polished'

const Wrapper = styled(Group)`
  padding-top: ${rem(48)};
  padding-bottom: ${rem(20)};
`

function ComponentBannerGroup(props: App.ComponentBannerGroup) {
  const title = renderMarkdown(props.title)
  const subtitle = props.subtitle ? renderMarkdown(props.subtitle) : undefined

  return (
    <Wrapper fullHeight direction="vertical" gap={32}>
      <LayoutContainer>
        <Group direction="vertical" gap={8}>
          <Heading variant="heading2" dangerouslySetInnerHTML={{ __html: title }}></Heading>
          {subtitle && <BodyText variant="medium" colour="neutral-two" dangerouslySetInnerHTML={{ __html: subtitle }}></BodyText>}
        </Group>
      </LayoutContainer>
      <FullWidthCarousel pageSize={2.2}>
        {props.banners && props.banners.length == 1 && (
          props.banners.map((banner) => <ComponentDynamicBanner key={banner.title} slug={props.slug} {...banner} size="large" />)
        )}
        {props.banners && props.banners.length > 1 && (
          props.banners.map((banner) => <ComponentDynamicBanner key={banner.title} slug={props.slug} {...banner} size="medium" />)
        )}
      </FullWidthCarousel>
    </Wrapper>
  )
}

export default ComponentBannerGroup
